module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-report-5.6c6aad06.svg";